module.exports = "//public.getcloudapp.com/packs/media/images/icons-announcement-34093f6b8530421aaddecd8239ad930b.svg";